export function extractVxeTableColumns(tableRef) {
  if (!tableRef || !tableRef.getColumns) {
    return [];
  }

  try {
    const columns = tableRef.getColumns();
    return columns
      .filter(col => col.property && col.title)
      .map(col => ({
        label: col.title,
        value: col.property
      }));
  } catch (error) {
    return [];
  }
}
